import { useEffect, useState } from "react";
import { api, type Job } from "../api";

export default function Jobs() {
  const [jobs, setJobs] = useState<Job[]>([]);
  const [status, setStatus] = useState<string>("new");
  const [error, setError] = useState("");
  const [open, setOpen] = useState<number | null>(null);

  useEffect(() => {
    load(status);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  async function load(filter: string) {
    setError("");
    try {
      setJobs(await api.jobs(filter === "all" ? undefined : filter, 200));
    } catch (e) {
      setError((e as Error).message);
    }
  }

  async function mark(id: number, next: string) {
    try {
      await api.setJobStatus(id, next);
      await load(status);
    } catch (e) {
      setError((e as Error).message);
    }
  }

  return (
    <div>
      <h2>Jobs</h2>
      <div style={{ display: "flex", gap: 8, marginBottom: 14 }}>
        {["all", "new", "contacted", "applied", "closed"].map((s) => (
          <button key={s} className={status === s ? "primary" : ""} onClick={() => setStatus(s)}>
            {s}
          </button>
        ))}
      </div>
      {error && <p className="err">{error}</p>}
      <div className="card">
        <table>
          <thead>
            <tr><th>Score</th><th>Title</th><th>Company</th><th>Location</th><th>Seniority</th><th>Source</th><th>Status</th><th>Actions</th></tr>
          </thead>
          <tbody>
            {jobs.map((j) => (
              <>
                <tr key={j.id}>
                  <td className="score">{Math.round(j.score)}</td>
                  <td>
                    <span className="expand" onClick={() => setOpen(open === j.id ? null : j.id)}>{j.title}</span>
                    <div className="muted">{j.skills.slice(0, 4).map((s) => <span key={s} className="tag">{s}</span>)}</div>
                  </td>
                  <td>{j.company}</td>
                  <td className="muted">{j.location || "—"}</td>
                  <td className="muted">{j.seniority}</td>
                  <td className="muted">{j.source}</td>
                  <td><span className={`badge ${j.status}`}>{j.status}</span></td>
                  <td>
                    <div className="row-actions">
                      <button onClick={() => mark(j.id, "applied")}>Mark applied</button>
                      <button className="danger" onClick={() => mark(j.id, "closed")}>Dismiss</button>
                    </div>
                  </td>
                </tr>
                {open === j.id && (
                  <tr key={`${j.id}-detail`}>
                    <td colSpan={8}>
                      <div className="detail">
                        {j.reasons.length > 0 && <><b>Why matched:</b> {j.reasons.join("; ")}<br /></>}
                        <b>URL:</b> {j.source_url ? <a href={j.source_url} target="_blank" rel="noreferrer">{j.source_url}</a> : "—"}<br />
                        {j.salary_min != null && <><b>Salary:</b> {j.salary_min}–{j.salary_max}<br /></>}
                        {j.description ? <><b>Description:</b> {j.description}</> : null}
                      </div>
                    </td>
                  </tr>
                )}
              </>
            ))}
            {jobs.length === 0 && (
              <tr><td colSpan={8} className="muted">No jobs with status “{status}”.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}